import React from 'react'
import styled from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  calculateMobileResponsiveSize
} from 'styles/media-queries'
import { Link } from 'gatsby'
import IcoClose from 'icons/ico_close.svg'

export const Wrapper = styled.div`
  .cookies-banner {
    position: fixed;
    bottom: ${calculateResponsiveSize(20)};
    left: ${calculateResponsiveSize(142)};
    right: ${calculateResponsiveSize(142)};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${calculateResponsiveSize(12)} ${calculateResponsiveSize(60)} ${calculateResponsiveSize(12)} ${calculateResponsiveSize(20)};
    font-size: ${calculateResponsiveSize(14)};
    color: #52403A;
    line-height: 1;
    background: #F2EEE8;
    opacity: 0;
    visibility: hidden;
    transform: translateY(150%);
    transition: opacity 1s, transform 1s;
    z-index: 1000;
    [dir="rtl"] & {
      padding: ${calculateResponsiveSize(12)} ${calculateResponsiveSize(20)} ${calculateResponsiveSize(12)} ${calculateResponsiveSize(60)};
    }
  }
  &.show {
    .cookies-banner {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }
  }
  .cookies-banner-accept-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${calculateResponsiveSize(24)};
    padding: 0 ${calculateResponsiveSize(12)};
    font-size: ${calculateResponsiveSize(12)};
    color: #F2EEE8;
    line-height: 1;
    font-weight: 600;
    letter-spacing: ${calculateResponsiveSize(3.84)};
    text-transform: uppercase;
    border: 0;
    background: #52403A;
    transition: color 0.25s, background 0.25s;
    cursor: pointer;
    /* &:hover {
      color: #000000;
      background: #ffffff;
    } */
  }
  ${mediaMax('mobile')} {
    .cookies-banner {
      bottom: 0;
      left: 0;
      right: 0;
      flex-direction: column;
      align-items: flex-start;
      gap: ${calculateMobileResponsiveSize(7)};
      padding: ${calculateMobileResponsiveSize(9)} ${calculateMobileResponsiveSize(72)} ${calculateMobileResponsiveSize(12)} ${calculateMobileResponsiveSize(20)};
      font-size: ${calculateMobileResponsiveSize(10)};
      font-weight: 700;
      line-height: 1.4;
      letter-spacing: ${calculateMobileResponsiveSize(3.2)};
      text-transform: uppercase;
      [dir="rtl"] & {
        padding: ${calculateMobileResponsiveSize(9)} ${calculateMobileResponsiveSize(20)} ${calculateMobileResponsiveSize(12)} ${calculateMobileResponsiveSize(72)};
      }
    }
    .cookies-banner-accept-btn {
      height: ${calculateMobileResponsiveSize(18)};
      padding: 0 ${calculateMobileResponsiveSize(10)};
      font-size: ${calculateMobileResponsiveSize(9)};
      letter-spacing: ${calculateMobileResponsiveSize(2.88)};
    }
  }
`

export const Content = styled.div``

export const LinkItem = styled((props) => <Link {...props} />)`
  text-decoration: none;
  color: #52403A;
  &:hover {
    text-decoration: underline;
  }
`

export const ButtonClose = styled.div`
  position: absolute;
  top: 50%;
  right: ${calculateResponsiveSize(20)};
  width: ${calculateResponsiveSize(19)};
  height: ${calculateResponsiveSize(12)};
  background: url(${IcoClose}) center center no-repeat;
  background-size: auto 100%;
  transform: translateY(-50%);
  transition: transform 0.25s;
  cursor: pointer;
  &:hover {
    transform: translateY(-50%) scale(1.15);
  }
  [dir="rtl"] & {
    right: auto !important;
    left: ${calculateResponsiveSize(20)};
  }
  ${mediaMax('mobile')} {
    top: ${calculateMobileResponsiveSize(14)};
    right: ${calculateMobileResponsiveSize(20)};
    width: ${calculateMobileResponsiveSize(24)};
    height: ${calculateMobileResponsiveSize(14)};
    transform: translateY(0);
    &:hover {
      transform: translateY(0) scale(1.15);
    }
    [dir="rtl"] & {
      left: ${calculateMobileResponsiveSize(20)};
    }
  }
`
